import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import useInfiniteScroll from "jd-library/useInfiniteScroll";
import SliderWrapper from "jd-library/SliderWrapper";
import toastMessageActions from "jd-library/toastMessageActions";
import historyHandler from "jd-library/historyHandler";
import { showHideLoader } from '../../actions/index';
import {   setVariantProductData } from '../../actions/variants'
import SingleBatch from "./SingleBatch";
import style from "./Styles/general-details.scss";
import "./Styles/inventory-batches.scss";
import { fetchProductAndEdit, getListingData,updateEditProductDetail } from "../../actions/products";
import Loader from "../../common/Loader/Loader";
import Button from "jd-library/Button";
import InventoryProductInfo from "./InventoryProductInfo";
import AddInventoryBatch from "./AddInventoryBatch";
import CommissionModal from "../add-edit-product/CommissionModal";
import ShadowBatchModal from "./ShadowBatchModal";
import MRPCommissionDetail from "../../common/UpdateMRP/MRPCommissionDetail";

const InventoryBatches = (props) => {
  const { deviceData,oldSellOnlineObj } = props;
  const [inventoryData, setInventoryData] = useState(() => ({
    isFetching: true,
    data: null,
    error: null
  }));
  const [sliderContRef, setSliderContRef] = useState(null);
  const [headerRaised, setHeaderRaised] = useState(false);
  const [errorObj, updateError] = useState([]);
  const [addInventory, showAddInventory] = useState(false);
  const [shadowBatchModal, showShadowBatchModal] = useState(false)

  const [commissionModal, toggleCommissionModal] = useState({ show: false });
  const [commissionModalData, setCommissionModalData] = useState({});
  const [CommsionModalVisibility, setCommsionModalVisibility] = useState(false)
  
  useEffect(() => {
    document.body.classList.add("bdyFixed");
    return () => {
      document.querySelector('body').classList.remove('bdyFixed');
    }
  }, [])

  const leftIconArr = [
    {
      className: "icon-HDRback",
      onClick: () => handleSliderHidden(),
    },
  ];
  const Add_itemInfo={
    manufacturing_date:'',
    best_before:'',
    bestBeforeUnit:'months',
    expiry_date:'',
    imageUrl:props.itemInfo?.imageUrl?props.itemInfo.imageUrl.split(',')[0]:"",
    productName:props.itemInfo.productName,
    productId: props.itemInfo.productId
  }
  const rightIconArr =
    deviceData && !deviceData.isMobile && !props.FromMarketPlaceInv
      ? [
        {
          className: "icon-HDRcross",
          onClick: () => handleSliderHidden({ closeAll: true }),
        },
      ]
      : [];
  if (props.FromMarketPlaceInv) {
    rightIconArr.push({
      className: 'add-batch',
      isText: true,
      label: (<><i className={'icon-plus'} ></i>ADD</>),
      onClick: () => {
        if (inventoryData.data?.isShadow && props.FromMarketPlaceInv) {
          showShadowBatchModal(true);
        }
        else {
          showAddInventory(true)
        }
      }
    })
  }
  const onHidden = () => {
    showAddInventory(false)
  }
  const handleInventorySave = () => {
    historyHandler.closeCurrent();
    fetchData(1).then((inventoryList) => {
      setInventoryData(() => ({ error: null, isFetching: false, data: inventoryList }));
    });
  }

  const fetchData = (currentPage = 1) => {
    const params = {
      productId: props.itemInfo.productId,
      currentPage: currentPage,
      pageSize: 15,
      token: props.session.token,
    };
    return new Promise((resolve, reject) => {

      axios
        .get("/marketplace/static/php/web/b2bWebsite.php?action=fetchConsignmentData", {
          params,
        })
        .then(({ data }) => {
          if (data?.results) {
            let results = data.results;
            for (let i = 0; i < results.length; i += 1) {
              if(results[i].mrp_status === 'IMAGES REQUIRED' || results[i].mrp_status === 'REJECTED'){
                delete results[i].mrp_images;
                delete results[i].mrp_front_img;
                results[i].mrp_validated = true;
              }
              results[i]['mrp_list'] = data.mrp_list;
              results[i].isTemplate = data?.isTemplate || null;
            }

            const inventoryList = [];
            results.forEach((item, key) => {
              let inputObject = {
                isModified: false,
              };
              const inputKeys = Object.keys(item);
              const includeKeys = [
                "mrp",
                "selling_price",
                "cost_price",
                "inStock",
                "barcode",
                "consignment_no_display",
              ];
              inputKeys.forEach((inputKey) => {
                if (item.hasOwnProperty(inputKey)) {
                  if (includeKeys.includes(inputKey)) {
                    inputObject[inputKey] = {
                      key: `${inputKey}${key}`,
                      value: item[inputKey],
                      errorMessage: "",
                      isWarning: false,
                    };
                    if (inputKey == "inStock") {
                      inputObject["oldTotalStock"] = item[inputKey];
                    }
                    } else if (inputKey == 'manufacturing_date' || inputKey == 'expiry_date') {                    let tempDateObj = item[inputKey] ? item[inputKey].split('T')[0] : '';
                    let manufDate = tempDateObj.split('-').reverse();
                    inputObject[inputKey] = {
                      key: `${inputKey}${key}`,
                      value: manufDate.join('/'),
                      errorMessage: "",
                      isWarning: false,
                    };

                    if(inputKey=="expiry_date"){
                      // let expiryBy = { value: inputObject['expiry_date']?.value ? 'expiry_date' : 'manufacturing_date' }
                      // // inputObject[inputKey] = manufDate.join('/');                    
                      // inputObject['expiryBy'] = {...expiryBy};
                      inputObject["expiryBy"]={value:item?.manufacturing_date_flag=="1"?"manufacturing_date":"expiry_date"}
                    }
                  }
                  // else if (inputKey == "best_before") {
                  //   inputObject[inputKey] = {
                  //     key: `${inputKey}${key}`,
                  //     value: item[inputKey],
                  //     errorMessage: "",
                  //     isWarning: false,
                  //   };
                  //   inputObject["best_before"] = item[inputKey] ? item[inputKey] : "";
                  // }
                  else if (inputKey == "best_before") {
                    let splitBestBefore = item[inputKey]
                    ? item[inputKey].split("-")
                    : [];
                    inputObject[inputKey] = {
                      key: `${inputKey}${key}`,
                      value: splitBestBefore[0],
                      errorMessage: "",
                      isWarning: false,
                    };
                    let bestBeforeUnit = { value: splitBestBefore[1] ? splitBestBefore[1].toLowerCase() : "months" }

                    // inputObject["best_before"] = item[inputKey] ? splitBestBefore[0] : "";
                    inputObject["best_before_unit"] = { ...bestBeforeUnit }
                  } else {
                    inputObject[inputKey] = item[inputKey];
                  }
                  inputObject["isApplicableExpDate"] =
                    item["best_before"] || item["manufacturing_date"]
                      ? true
                      : false;
                }
              });
              if(props.session.viaOmni){
                // inputObject["expiry_date"]={value:item?.manufacturing_date_flag=="1"?"manufacturing_date":"expiry_date"}
                inputObject["expiryBy"]={value:item?.manufacturing_date_flag=="1"?"manufacturing_date":"expiry_date"}
              }
              inventoryList.push(inputObject);
            });
            if(props.addNew){
              inventoryList.unshift({
                addNew:true,
                imageUrl : props.itemInfo?.imageUrlArr?.length? props.itemInfo.imageUrlArr[0]?.imgURL:'',
                productName: props.itemInfo.productName,
                productId: props.itemInfo.productId,
                mrp:{value:""},
                selling_price:{value:""},
                inStock:{value:""},
                cost_price:{value:""},
                expiry_date:{value:""},
                manufacturing_date:{value:""},
                best_before:{value:""},
                barcode:{value:""},
                best_before_unit:{value:'months'},
                manufacturing_date_flag:"1",
                expiryBy:{value:"manufacturing_date"},
                consignment_no_display:{value:""},
              })
            }
            const resultObj = {
              currPage: 1,
              inventoryList,
              islastPage: data?.islastPage,
              expiry_date_flag: data?.expiry_date_flag,
              isShadow: data?.isShadow,
              mrp_list: data?.mrp_list
            }
            resolve(resultObj);
          }
          else {
            resolve({})
          }
        });
    });
  };

  useEffect(() => {
    setInventoryData(() => ({ ...inventoryData, isFetching: true }))
    fetchData(1).then((inventoryList) => {
      setInventoryData(() => ({ error: null, isFetching: false, data: inventoryList }));
    });
  }, []);

  const [isFetching, setIsFetching] = useInfiniteScroll({
    loadMoreCB: () => {
      const { curPage, inventoryList, islastPage } = inventoryData.data;
      if (!islastPage) {
        fetchData(curPage + 1).then((data) => {
          let resultObj = {
            curPage: curPage + 1,
            inventoryList: [...inventoryList, ...data.inventoryList],
            islastPage: data.islastPage
          };
          setInventoryData(() => ({ ...resultObj }));
          setIsFetching(false);
        });
      }
    },
    scrollContainer: sliderContRef,
    threshold: 500,
    useWindow: false,
    deps: [sliderContRef],
  });

  const formatDate = (value) => {
    if (value) {
      var date = new Date(value);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return `${d}/${m}/${y}`;
    }
    return null;
  };

  function formatDateToSend(date) {
    if (date && date.toString().indexOf("/") > -1) {
      var strDate = date.split("/");
      return [strDate[2], strDate[1], strDate[0]].join('-');
    } else {
      return null;
    }
  }
  let expiry_date_flag = Number(props.expiryFlag) || Number(inventoryData.data?.expiry_date_flag);

  let lastMrpProofErrors=null;

  const validateData = (data, index) => {
    let errMsg = "";
    let tempForm = { ...data };
    tempForm.errors = {};
    if (!tempForm.inStock.value ||
      Number(tempForm.inStock.value) == 0
    ) {
      if (String(tempForm.inStock.value).length === 0) {
        tempForm.inStock.errorMessage = "Please Enter Quantity";
        errMsg = "Please Enter Quantity";
      }
      if(Number(tempForm.inStock.value) === 0){
        tempForm.inStock.errorMessage = "Cannot be 0";
        errMsg = "Quantity cannot be 0";
      }
      if (!tempForm.mrp.value) {
        tempForm.mrp.errorMessage = "Please Enter MRP";
      }
      if (!tempForm.selling_price.value) {
        tempForm.selling_price.errorMessage = "Please Enter Price";
      }
    } else if(Number(tempForm.inStock.value) > 100) {
      tempForm.inStock.errorMessage = 'Cannot be More than 100';
      errMsg = errMsg ? errMsg : 'Quantity Cannot be More than 100' 
    } else if (!tempForm.mrp.value || Number(tempForm.mrp.value) === 0) {
      if (!tempForm.mrp.value) {
        tempForm.mrp.errorMessage = "Please Enter Price";
        errMsg = errMsg ? '' : "Please Enter MRP Price";
      }
      if (String(tempForm.mrp.value).length > 0 && Number(tempForm.mrp.value) === 0) {
        tempForm.mrp.errorMessage = "Cannot be 0";
        errMsg = "MRP Price Value cannot be 0";
      }
      if (!tempForm.selling_price.value) {
        tempForm.selling_price.errorMessage = 'Please Enter Price';
      }
    } else if (!tempForm.selling_price.value) {
      tempForm.selling_price.errorMessage = "Please Enter Price";
      errMsg = "Please Enter Price";
    }
    if (
      tempForm.selling_price.value &&
      Number(tempForm.selling_price.value) == 0
    ) {
      tempForm.selling_price.errorMessage = "Cannot be 0";
      errMsg = errMsg ? errMsg : "Selling Price Value Cannot be 0";
    }
    if (String(tempForm.mrp.value).length > 0 && Number(tempForm.mrp.value) === 0) {
      tempForm.mrp.errorMessage = "Cannot be 0";
      errMsg = tempForm.inStock.errorMessage ? errMsg : "MRP Price Value cannot be 0";
    }

    if (Number(tempForm.mrp.value) === 1) {
      tempForm.mrp.errorMessage = "Invalid Value";
      errMsg = "MRP Value is Invalid";
    }
    if (
      Number(tempForm.selling_price.value) == 1 ||
      Number(tempForm.selling_price.value) < 0
    ) {
      tempForm.selling_price.errorMessage = "Invalid Value";
      errMsg = errMsg ? errMsg : "Selling Price Value is Invalid";
    }
    if (tempForm.selling_price.errorMessage == "Higher than MRP") {
      errMsg = errMsg ? errMsg : "Selling Price Cannot be Higher than MRP";
    }

    if(props.session.viaOmni){
      errMsg=""
      Object.entries(tempForm).forEach(([key,val])=>val?.errorMessage?val.errorMessage="":"")
    }


    if(expiry_date_flag){
      const getDateObj = (dateString) => {
        let dateStr = typeof dateString === 'string' ? dateString : dateString.value;
        if(dateStr)
        {
            var dateParts = dateStr.split('/');
            // month is 0-based, that's why we need dataParts[1] - 1
            var dateObj = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
            return(dateObj);
          }
      }
      const currentDate = new Date();

      if(!tempForm.consignment_no_display.value) {
        errMsg = errMsg ? errMsg : 'Please Enter Batch / Lot Number';
        tempForm.consignment_no_display.errorMessage = 'Please Enter Batch / Lot Number'
      } else if (tempForm.consignment_no_display.value.length < 4) {
        errMsg = errMsg ? errMsg : "Batch Lot Number must be at least 4 characters long";
        tempForm.consignment_no_display.errorMessage = "Batch Lot Number must be at least 4 characters long";
      }
      if(tempForm.expiryBy.value == 'expiry_date') {
        if (!tempForm.expiry_date.value) {
          errMsg = errMsg ? errMsg : 'Please Enter Expiry Date';
          tempForm.expiry_date.errorMessage = 'Please Enter Expiry Date';
        }else {
          let value = getDateObj(tempForm.expiry_date.value);
          if(value){
            currentDate.setHours(value.getHours(), value.getMinutes(), value.getSeconds(), value.getMilliseconds())
            //Ignore time param while comparing two dates.
          }
          if(currentDate > value) {
            errMsg = errMsg ? errMsg : "You have Entered Expired Date";
            tempForm.expiry_date.errorMessage = "You have Entered Expired Date";
          }
        }
      } else {
        let checkExpirtyCalc = true;
        if (!tempForm.manufacturing_date.value) {
            errMsg = errMsg ? errMsg : 'Please Enter Manufacturing Date';
            tempForm.manufacturing_date.errorMessage = 'Please Enter Manufacturing Date';
            checkExpirtyCalc = false;
        }
        if (!tempForm.best_before.value) {
            errMsg = errMsg ? errMsg : 'Please Enter Best Before';
            tempForm.best_before.errorMessage = 'Please Enter Best Before';
            checkExpirtyCalc = false;
        }else if(tempForm.best_before.value == '0') {
            errMsg = errMsg ? errMsg : 'Please Enter Valid Value';
            tempForm.best_before.errorMessage = 'Please Enter Valid Value';
            checkExpirtyCalc = false;
        }
        let value = getDateObj(tempForm.manufacturing_date.value);
        if(checkExpirtyCalc && value) {
          currentDate.setHours(value.getHours(), value.getMinutes(), value.getSeconds(), value.getMilliseconds());

          var expDateByBestBefore = new Date(currentDate);
          var bestBeforeInDays = Number(tempForm.best_before.value);
          var bestBeforeUnit = tempForm.best_before_unit.value || 'months';
          if(bestBeforeUnit == 'months'){
            bestBeforeInDays = bestBeforeInDays * 30;
          }else if(bestBeforeUnit == 'years'){
              bestBeforeInDays = bestBeforeInDays * 365;
          }
          expDateByBestBefore.setTime( value.getTime() + bestBeforeInDays * 86400000 );
          if(currentDate < value){
            errMsg = errMsg ? errMsg : 'You have Entered Future Date as Manufacturing Date';
            tempForm.manufacturing_date.errorMessage = 'You have Entered Future Date as Manufacturing Date';
          }else if(currentDate > expDateByBestBefore) {
            errMsg = errMsg ? errMsg : 'Product has Already Expired.';
            tempForm.manufacturing_date.errorMessage = 'Product has Already Expired.';
          }
        }
      }
    }

    let mrpProofErrorEncountered=false;
    if(tempForm.mrp_validated && !tempForm.mrp_front_img ){
      tempForm.productFrontProofError = "";      
      updateError((errorObj) => {
        let arr = errorObj?.length ? [...errorObj] : [];
        arr[index] = {
          ...arr[index],
          productFrontProofError: ''
        }
        return arr;
      });
      // lastMrpProofErrors=!lastMrpProofErrors?"Please Attach Photo Proof":lastMrpProofErrors;
      lastMrpProofErrors="";
      mrpProofErrorEncountered=true
    }
    if(tempForm.mrp_validated && !tempForm.mrp_images ){
      tempForm.mrpError = "";
      updateError((errorObj) => {
        let arr = errorObj?.length ? [...errorObj] : [];
        arr[index] = {
          ...arr[index],
          mrpError: ''
        }
        return arr;
      });
      // lastMrpProofErrors=!lastMrpProofErrors?"Please Attach Photo Proof":lastMrpProofErrors;
      lastMrpProofErrors="";
      mrpProofErrorEncountered=true
    }
    if(mrpProofErrorEncountered && !props.session.viaOmni){
      errMsg=lastMrpProofErrors;
    } else{
      lastMrpProofErrors=null;
    }

    let consignmentList = [...inventoryData.data.inventoryList];
    consignmentList[index] = tempForm;
    // updateError(tempForm.errors);
    setInventoryData(() => ({ ...inventoryData, data: { ...inventoryData.data, inventoryList: consignmentList } }));
    return errMsg;
  };

  const updateDefaultBatchToEditSlider=()=>{
    axios
    .get(
      `/marketplace/static/php/web/b2bWebsite.php?action=fetchConsignmentData&token=${props.session.token}&productId=${props.itemInfo.productId}&currentPage=1&pageSize=15`
    ).then((response) => {
      let batches = response.data.results|| [];
      let default_batch=null;
      for(let i = 0; i <batches.length; i++) {
        if(batches[i]?.default_batch){            
          default_batch={
            mrp: batches[i].mrp?.toString()?.replaceAll(',',''),
            sellingPrice: batches[i].selling_price?.toString()?.replaceAll(',',''),
            quantity:batches[i].inStock?.toString()?.replaceAll(',',''),
          }
        }
      }
      if(default_batch){
        oldSellOnlineObj.quantity=default_batch?.quantity;
        props.updateEditProductDetail([{
          key: "oldSellOnlineObj",
          value: oldSellOnlineObj
        },{
          key: "mrp",
          value: default_batch.mrp
        },{
          key: "quantity",
          value: default_batch.quantity
        },{
          key: "sellingOnlinePrice",
          value: default_batch.sellingPrice
        }])
      }
    })
  }

  const setVariantData=(data, index)=>{
    let temp = [...props.variantProductData]
    temp[index] = data;
    props.setVariantProductData(temp);
}

  const handleSave = (e) => {
    e.preventDefault(true);
    let noError = true;
    if (inventoryData.data?.isShadow && props.FromMarketPlaceInv) {
      showShadowBatchModal(true)
      return;
    }

    if (inventoryData.data?.inventoryList?.length) {
      let consignmentList = [];
      const supplierId = props.consignmentData?.supplierId
        ? props.consignmentData?.supplierId
        : props.supplierId;
      lastMrpProofErrors=null;
      inventoryData.data.inventoryList.map((itemData, index) => {


        if (itemData.isModified || true) {
          let expiryDate = "";
          let manufacturingDate = "";
          const expiryBy = itemData["expiryBy"].value; // its a current selected Tab manufacture vs expiry
          let finalBestBeforeVal =
            itemData["best_before"].value && itemData["best_before_unit"].value
              ? itemData["best_before"].value + "-" + itemData["best_before_unit"].value
              : "";
          if (expiryBy == "expiry_date") {
            expiryDate = formatDateToSend(itemData['expiry_date'].value);
            // expiryDate = itemData["expiry_date"].value;
            // expiryDate = expiryDate.replace(/\//g, "-");
            itemData["best_before"].value = "";
          } else if (
            expiryBy == "manufacturing_date" &&
            itemData["manufacturing_date"].value
          ) {
            manufacturingDate = formatDateToSend(itemData['manufacturing_date'].value);
            expiryDate=""
            // manufacturingDate = itemData["manufacturing_date"].value;
            // manufacturingDate = manufacturingDate.replace(/\//g, "-");
          }

          let isError = (!props.addNew || props.addNew && itemData.addNew)?validateData(itemData, index):false;
          if (!isError) {
            let consignmentObj = {
              mrp: Number(itemData.mrp.value),
              sellingPrice: Number(itemData.selling_price.value),
              costPrice: Number(itemData.cost_price.value),
              quantity: Number(itemData.inStock.value),
              // Number(itemData.oldTotalStock),
              barcode: itemData.barcode.value || "",
              // consignmentId: itemData.consignmentId,
              // discountRule: 0,
              // spPerPc: Number(itemData.spPerPc?.value) || 0,
              // newConsignmentNo: itemData.consignment_no.value || "",
              best_before:manufacturingDate? finalBestBeforeVal || "":"",
              manufacturing_date: manufacturingDate || "",
              // consignment_no_display: itemData.consignment_no_display.value || "",
              newConsignmentNo: itemData.consignment_no_display.value || "",
              consignmentNo: itemData.consignment_no || '',
              expiry_date: expiryDate || "",
              expiryDate: expiryDate || "",
              mrp_images: itemData?.mrp_images,
              mrp_front_img:itemData?.mrp_front_img
              // isBatchEnabled: false,
              // isApplicableExpDate:
              // itemData.manufacturingDate.value || itemData.expiryDate.value
              //   ? true
              // false,
            };

            consignmentList.push(consignmentObj);
          } else if (isError.length) {
            props.showToastMessage({
              showToastMessage: true,
              message: isError,
              type: "error",
            });
            noError = false;
          }
        }


      });
      if (consignmentList.length >= 1 && noError) {
        
        const params = {
          token: props.session.token,
          productId: props.itemInfo.productId,
          action: 'updateInventorybatch'
        };
        if(props.session?.viaOmni){
          params.viaOmni = 1
        }
        axios.post('/marketplace/static/php/web/b2bWebsite.php', consignmentList,
          {
            params,
            headers: {
              "Content-Type": "application/json"
            },
          }
        )
          .then((res) => {
            if (res.data.isSuccess) {
              const tempVar={...props.variantProductData[props.variantIndex]}
              tempVar.batchCount=consignmentList.length
              setVariantData(tempVar,props.variantIndex)
              updateDefaultBatchToEditSlider()
              if(!props.session.viaOmni) setCommsionModalVisibility(true)              
              // handleSliderHidden({ isSaved: true })
              if(props.isListing){
                props.updateProdList({ tabKey: props.tabKey || "inventoryCompliance" });
              }
              if(props.session.viaOmni){
                historyHandler.closeCurrent()
              }
            } else {
              props.showToastMessage({
                message: 'Invalid data please check',
                type: "error",
                duration: 5000,
              })
            }
            
          });
      } else if (!noError) {
        return;
      }
    } else {
      historyHandler.closeCurrent();
    }
  };

  const handleSliderHidden = (options = {}) => {
    props.onHidden && props.onHidden();
    if (inventoryData.data?.inventoryList?.length) {
      // let checkIsModified = false;
      // inventoryData.data?.inventoryList.map((itemData) => {
      //   if (itemData.isModified) {
      //     checkIsModified = true;
      //   }
      // });
      if (options.isSaved) {
        props.updateProduct ? props.updateProduct({
          cb: () => {
            props.updateList();
            if (props.FromMarketPlaceInv) {
              props.showToastMessage({
                showToastMessage: true,
                message: 'Product Inventory updated',
                type: "info"
              })
            }
            if (options.closeAll) {
              historyHandler.closeMultiSlider(2);
            } else {
              historyHandler.closeCurrent();
            }
          }
        }) :
          props.fetchProductEdit({
            productId: props.itemInfo.productId,
            token: props.session?.token,
            isObjectionable: props.itemInfo.isObjectionable,
            id: props.itemInfo.id,
            cb: () => {
              props.updateProdList({ tabKey: props.tabKey });
              if (options.closeAll) {
                historyHandler.closeMultiSlider(2);
              } else {
                historyHandler.closeCurrent();
              }
            },
          });
      } else {
        if (options.closeAll) {
          historyHandler.closeMultiSlider(2);
        } else {
          historyHandler.closeCurrent();
        }
      }
    } else {
      if (options.closeAll) {
        historyHandler.closeMultiSlider(2);
      } else {
        historyHandler.closeCurrent();
      }
    }
  };
  const updateInventoryList = ({ index, params }) => {
    const updatedList = inventoryData?.data?.inventoryList?.map((l, i) => i === index ?
      { ...params, isModified: true } : l);
    setInventoryData(() => ({ ...inventoryData, data: { ...inventoryData.data, inventoryList: updatedList } }))
  }

  const matchLowestPrice = (price) => {
    const updatedList = inventoryData?.data?.inventoryList?.map((cur, index) => {
      cur.selling_price.value = price.toString()?.replaceAll(',', '');
      return cur;
    });
    setInventoryData(() => ({ ...inventoryData, data: { ...inventoryData.data, inventoryList: updatedList } }))
  }

  return (
    <>
      <div className="inventory-batches-slider">
        <SliderWrapper
          header={{
            heading: <div className="slider-title">{props.componentlabel}</div>,
            // subHeading: (
            //   <div className="slider-subtitle">
            //     {props.itemInfo.productName || ""}
            //   </div>
            // ),
            variant: "secondary",
            className: `inventory-batches-slider add-edit-slider-header`,
            raised: headerRaised,
            hasBorder: true,
            leftIcons: leftIconArr,
            rightIcons: rightIconArr,
          }}
          footer={{
            className: "inventory-slider-footer",
            btnProps: !props.session.isReadOnly ? [
              {
                children: "Save",
                onClick: (e) => handleSave(e),
                disabled: inventoryData.isFetching || inventoryData.error
              },
            ] : [],
          }}
          slider={{
            className: "add-edit-slider inventory-batches-slider",
          }}
          onHidden={() => props.onHidden()}
          updateScrollContRef={(ref) => {
            setSliderContRef(ref);
          }}
          onScroll={(e) => setHeaderRaised(e.target.scrollTop > 5)}
        >
          <div className="inventory-list-container">
          {
            !props.session.viaOmni &&
            <InventoryProductInfo  ImageUrl={props.itemInfo?.imageUrl?props.itemInfo.imageUrl.split(',')[0]:""}  productName={props.itemInfo.productName}/>
          }
            {inventoryData.isFetching ?
              <Loader />
              : (inventoryData.data?.inventoryList?.map((item, key) =>(!props.addNew || props.addNew && item.addNew)? (
                <div className={`${style["general-details"]} side-padding ${props.FromMarketPlaceInv ? style['marketplace-inv']:''}`} key={key * 10}>
                  <SingleBatch
                    key={key * 10}
                    index={key}
                    item={item}
                    variantId={props.itemInfo.variantId}
                    inventoryData={inventoryData.data.inventoryList}
                    itemInfo={props.itemInfo}
                    updateInventory={updateInventoryList}
                    matchLowestPrice={matchLowestPrice}
                    FromMarketPlaceInv={props.FromMarketPlaceInv}
                    errorObj={errorObj}
                    updateError={updateError}
                    toggleCommissionModal={() => toggleCommissionModal({ show: true })}
                    consignmentNo={item.consignment_no}
                    productId={item.product_id}
                    sellingPrice={item.selling_price?.value}
                    setCommissionModalData={setCommissionModalData}
                    expiryFlag={expiry_date_flag}
                    isAddEdit={props.isAddEdit}
                    isInventoryCompliance={props.isListing}
                    disableSellOnlineCustom={props.disableSellOnlineCustom}
                    tabKey={props.tabKey}
                  />
                </div>
              ):<></>))}
              {!props.session.isReadOnly ? <div className={'btn-holder'}>
              <Button className={'inventory-slider-footer'} children={'Save'} onClick={e => handleSave(e)} disabled={inventoryData.isFetching || inventoryData.error} />
            </div> : null}
          </div>
        </SliderWrapper>
      </div>
      {addInventory && <AddInventoryBatch
                  FromMarketPlaceInv={props.FromMarketPlaceInv}
                  isShadow={inventoryData.data?.isShadow}
                  onHidden={onHidden}
                  expiryFlag={expiry_date_flag}
                  itemInfo={Add_itemInfo}
                  handleInventorySave={handleInventorySave}
                  mrp_list={inventoryData.data?.mrp_list}
                  hideMrp={props.itemInfo.isTemplate}
                  productData={{ mrp_list: [0] }}
                  tabKey={props.tabKey}
                  />
      }
      {commissionModal.show ? (
        <CommissionModal
          confirmClick={() =>
            toggleCommissionModal({ show: false })
          }
          onHidden={() => toggleCommissionModal({ show: false })}
          data={commissionModalData}
        />
      ) : null}
      {shadowBatchModal ? (<ShadowBatchModal onHidden={() => showShadowBatchModal(false)} />) : null}
      {CommsionModalVisibility ?
      <MRPCommissionDetail 
        updateList={props.updateList}
        productData={props.itemInfo} 
        batch_MRP={inventoryData.data?.inventoryList} 
        initialCommissionModalState={CommsionModalVisibility} 
        onCommissionModalStateChange={e => {
        setCommsionModalVisibility(e)
        } }
        onClose={() => {
          historyHandler.closeMultiSlider(1)
        }}
      />
      : null}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    deviceData: state.deviceData,
    consignmentData: state.items.consignmentData,
    session: state.session ? state.session : {},
    uomArr: state.uom,
    errors: state.items.errors,
    permissions: state.permissions,
    displayInfo: state.items.displayInfo,
    expiryFlag: state.productSpecification.expiryFlag,
    variantProductData: state.variants.variantProductData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // setInventoryData: (payload) => dispatch(setInventoryData(payload)),
    showHideLoader: (payload) => dispatch(showHideLoader(payload)),
    fetchProductEdit: (payload) => dispatch(fetchProductAndEdit(payload)),
    updateProdList: (payload) => dispatch(getListingData(payload)),
    setVariantProductData:(payload) => dispatch(setVariantProductData(payload)),
    showToastMessage: (payloaad) =>
      dispatch(toastMessageActions.showMessage(payloaad)),
      updateEditProductDetail:(payload)=>dispatch(updateEditProductDetail(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InventoryBatches);